export function formatFullName(leader: { firstName?: string; lastName?: string } = {}): string {
  return `${leader.firstName} ${leader.lastName}`.trim()
}
